import React from 'react';
import { useTranslation } from 'react-i18next';

type InfoboxProps = {
  endpoint: string;
};

const Infobox: React.FunctionComponent<InfoboxProps> = (props: InfoboxProps) => {
  const { endpoint } = props;
  const { t } = useTranslation();
  return (
    <div className="col-9">
      <h1 className="h2" aria-live="polite">
        {t(`customerService:contactUs.contactTitle`)}
      </h1>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphOne`)} </p>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphTwo`)} </p>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphThree`)} </p>
    </div>
  );
};
export default Infobox;
